module.exports = __webpack_public_path__ + "ffc440c8689f670415b6d445183585c9.png";